import { render, staticRenderFns } from "./cartDetails.vue?vue&type=template&id=10292588&scoped=true"
import script from "./cartDetails.vue?vue&type=script&lang=js"
export * from "./cartDetails.vue?vue&type=script&lang=js"
import style0 from "./cartDetails.vue?vue&type=style&index=0&id=10292588&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10292588",
  null
  
)

export default component.exports